/** Naranja eléctrico Sushi2Go — usar en todo el admin */
export const BRAND = {
  primary: "#E95735",
  primaryHover: "#d44a2c",
  primaryLight: "#fff4f0",
  primarySoft: "#ff8566",
  primaryShadow: "0 2px 10px rgba(233, 87, 53, 0.28)",
} as const;
